/* Le Valmier — Email popup behaviour (used by sections/lv-email-popup.liquid) */
(function () {
  if (customElements.get('lv-email-popup')) return;

  var SUBSCRIBED_KEY = 'lv_popup_subscribed';
  var DISMISSED_KEY = 'lv_popup_dismissed_at';
  var SUBMITTING_KEY = 'lv_popup_submitting';
  var CART_KEY = 'lv_popup_has_cart';
  var TEASER_HIDDEN_KEY = 'lv_popup_teaser_hidden';

  function read(store, key) {
    try { return window[store].getItem(key); } catch (e) { return null; }
  }
  function write(store, key, value) {
    try { window[store].setItem(key, value); } catch (e) {}
  }
  function remove(store, key) {
    try { window[store].removeItem(key); } catch (e) {}
  }

  // Remember (for this visit) that something went into the cart, so the popup stays out of the way.
  function markCart() { write('sessionStorage', CART_KEY, '1'); }
  document.addEventListener('cart:update', markCart);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && String(f.action).indexOf('/cart/add') !== -1) markCart();
  }, true);

  class LvEmailPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.body = this.querySelector('.lv-popup__body');
      this.form = this.querySelector('form');
      this.teaser = this.querySelector('[data-lv-teaser]');
      if (!this.dialog || !this.body) return;

      this.querySelectorAll('[data-lv-popup-close]').forEach((btn) => {
        btn.addEventListener('click', () => this.close(true));
      });
      this.dialog.addEventListener('cancel', (e) => { e.preventDefault(); this.close(true); });
      this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.close(true); });

      var copyBtn = this.querySelector('[data-lv-copy]');
      if (copyBtn) copyBtn.addEventListener('click', () => this.copyCode());

      if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));

      if (this.teaser) {
        var openBtn = this.teaser.querySelector('[data-lv-teaser-open]');
        var closeBtn = this.teaser.querySelector('[data-lv-teaser-close]');
        if (openBtn) openBtn.addEventListener('click', () => { this.show('email'); this.open(); });
        if (closeBtn) closeBtn.addEventListener('click', () => {
          write('sessionStorage', TEASER_HIDDEN_KEY, '1');
          this.updateTeaser();
        });
      }

      var initial = this.body.dataset.initialStep;
      var cameFromPopup = read('sessionStorage', SUBMITTING_KEY) === '1' ||
        window.location.hash === '#' + this.dataset.formId;

      if (cameFromPopup && initial === 'success') {
        remove('sessionStorage', SUBMITTING_KEY);
        write('localStorage', SUBSCRIBED_KEY, '1');
        this.show('success');
        this.open();
        return;
      }
      if (cameFromPopup && initial === 'email') {
        remove('sessionStorage', SUBMITTING_KEY);
        this.show('email');
        this.open();
        return;
      }

      if (this.dataset.designMode === 'true') {
        document.addEventListener('shopify:section:select', (e) => {
          if (e.detail && e.detail.sectionId === this.dataset.sectionId) { this.show('email'); this.open(); }
        });
        document.addEventListener('shopify:section:deselect', (e) => {
          if (e.detail && e.detail.sectionId === this.dataset.sectionId) this.close(false);
        });
        return;
      }

      this.updateTeaser();
      if (this.shouldAutoOpen()) this.armTriggers();
    }

    // Offer is relevant: not subscribed, not a marketing/returning customer, not on the cart page.
    offerAllowed() {
      if (this.dataset.hideForCustomer === 'true') return false;
      if (this.dataset.cartPage === 'true') return false;
      if (read('localStorage', SUBSCRIBED_KEY) === '1') return false;
      return true;
    }

    hasCart() {
      return parseInt(this.dataset.cartCount || '0', 10) > 0 || read('sessionStorage', CART_KEY) === '1';
    }

    shouldAutoOpen() {
      if (!this.offerAllowed()) return false;
      if (this.hasCart()) return false;
      var dismissedAt = parseInt(read('localStorage', DISMISSED_KEY) || '0', 10);
      var days = parseFloat(this.dataset.dismissDays || '7');
      if (dismissedAt && Date.now() - dismissedAt < days * 86400000) return false;
      return true;
    }

    updateTeaser() {
      if (!this.teaser) return;
      var visible = this.dataset.showTeaser === 'true' &&
        this.offerAllowed() &&
        read('sessionStorage', TEASER_HIDDEN_KEY) !== '1' &&
        !this.dialog.open;
      this.teaser.hidden = !visible;
    }

    armTriggers() {
      var fired = false;
      var timer = null;
      var self = this;
      var scrollTarget = Math.min(95, Math.max(5, parseFloat(this.dataset.scrollPercent || '50')));
      var delay = Math.max(0, parseFloat(this.dataset.delay || '25')) * 1000;

      function cleanup() {
        window.removeEventListener('scroll', onScroll);
        document.removeEventListener('mouseout', onExit);
        if (timer) window.clearTimeout(timer);
      }
      function fire() {
        if (fired) return;
        if (!self.shouldAutoOpen()) { fired = true; cleanup(); return; }
        if (document.querySelector('dialog[open]:not(.lv-popup__dialog)')) {
          // Another modal (cart, search...) is open - try again a bit later.
          window.clearTimeout(timer);
          timer = window.setTimeout(fire, 4000);
          return;
        }
        fired = true;
        cleanup();
        self.show('email');
        self.open();
      }
      function onScroll() {
        var doc = document.documentElement;
        var max = Math.max(1, doc.scrollHeight - window.innerHeight);
        if ((window.scrollY / max) * 100 >= scrollTarget) fire();
      }
      function onExit(e) {
        if (!e.relatedTarget && e.clientY <= 0) fire();
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        document.addEventListener('mouseout', onExit);
      }
      timer = window.setTimeout(fire, delay);
    }

    show(step) {
      this.querySelectorAll('[data-step]').forEach((el) => {
        el.hidden = el.dataset.step !== step;
      });
      if (step === 'email') {
        var input = this.querySelector('input[type="email"]');
        if (input && this.dialog.open) window.setTimeout(() => input.focus(), 50);
      }
    }

    open() {
      if (this.dialog.open) return;
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
      document.documentElement.classList.add('lv-popup-open');
      this.updateTeaser();
      requestAnimationFrame(() => this.dialog.classList.add('is-visible'));
    }

    close(remember) {
      if (!this.dialog.open) return;
      if (remember && read('localStorage', SUBSCRIBED_KEY) !== '1') {
        write('localStorage', DISMISSED_KEY, String(Date.now()));
      }
      this.dialog.classList.remove('is-visible');
      document.documentElement.classList.remove('lv-popup-open');
      var finish = () => { if (this.dialog.open) this.dialog.close(); this.updateTeaser(); };
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) finish(); else window.setTimeout(finish, 300);
    }

    onSubmit(e) {
      var input = this.querySelector('input[type="email"]');
      var err = this.querySelector('[data-lv-client-error]');
      var valid = input && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim());
      if (!valid) {
        e.preventDefault();
        if (err) err.hidden = false;
        if (input) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
        return;
      }
      if (err) err.hidden = true;
      write('sessionStorage', SUBMITTING_KEY, '1');
    }

    copyCode() {
      var code = this.dataset.code;
      var hint = this.querySelector('[data-lv-copy-hint]');
      var done = () => {
        if (!hint) return;
        var original = hint.dataset.original || hint.textContent;
        hint.dataset.original = original;
        hint.textContent = '\u2713';
        window.setTimeout(() => { hint.textContent = original; }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, done);
      } else {
        done();
      }
    }
  }

  customElements.define('lv-email-popup', LvEmailPopup);
})();